export default __webpack_public_path__ + "static/Cover-b3eb03e7dcaf3e0df4f9cb15d8d5189d.png";